import http from './httpService';
import config from './../config.json';

export const getTodayViewers = ({cancelToken}) => {
	return http.get(`${config.api_viewer}/today`, {cancelToken});
}
export const getDailyViews = (params,{cancelToken}) => {
	return http.get(`${config.api_viewer}/daily`, {cancelToken, params});
}
export const getSummaryViews = ({cancelToken}) => {
	return http.get(`${config.api_viewer}/summary`, {cancelToken});
}
